<template>
    <div class="election-page">
        <div class="election-hero">
            <!-- <div class="hero-bg-shapes">
                <div class="shape shape-1"></div>
                <div class="shape shape-2"></div>
                <div class="shape shape-3"></div>
            </div> -->
            <div class="hero-content">
                <div class="hero-badge">
                    <a-icon type="star" theme="filled" />
                    <span>MUIC Staff Election 2026</span>
                </div>
                <h1 class="hero-title">
                    Staff Council <span class="accent">Election</span>
                </h1>
                <p class="hero-subtitle font-web">
                    เลือกตั้งคณะกรรมการสภาเจ้าหน้าที่ วิทยาลัยนานาชาติ ม.มหิดล ปี 2569 — ร่วมเลือกผู้แทนของคุณ
                </p>
                <div class="hero-timer">
                    <div class="timer-item">
                        <span class="timer-value">{{ countdown.days }}</span>
                        <span class="timer-label">Days</span>
                    </div>
                    <div class="timer-separator">:</div>
                    <div class="timer-item">
                        <span class="timer-value">{{ countdown.hours }}</span>
                        <span class="timer-label">Hours</span>
                    </div>
                    <div class="timer-separator">:</div>
                    <div class="timer-item">
                        <span class="timer-value">{{ countdown.minutes }}</span>
                        <span class="timer-label">Minutes</span>
                    </div>
                    <div class="timer-separator">:</div>
                    <div class="timer-item">
                        <span class="timer-value">{{ countdown.seconds }}</span>
                        <span class="timer-label">Seconds</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Party Cards Section -->
        <div class="election-content">
            <div class="section-header">
                <h2 class="section-title font-web">
                    <a-icon type="team" /> กลุ่มผู้สมัครรับเลือกตั้ง
                </h2>
                <p class="section-desc font-web">เลือกกลุ่มที่คุณต้องการสนับสนุน</p>
                <div class="section-rules font-web"
                    style="margin-top: 16px; padding: 12px 16px; background-color: #fff2e8; border: 1px solid #ffd591; border-radius: 8px; color: #d46b08; font-size: 13px; display: inline-block; max-width: 650px; text-align: left; line-height: 1.5;">
                    <a-icon type="info-circle" style="margin-right: 6px; color: #fa8c16;" />
                    หากทำการกดยืนยันแล้วจะไม่สามารถลงคะแนน หรือแก้ไขได้อีกในภายหลัง ( 1 User ต่อ 1 สิทธิ์ลงคะแนน )
                    <div
                        style="font-size: 12px; color: #8c8c8c; margin-top: 4px; padding-left: 20px; font-family: sans-serif;">
                        Please note: If your submission has been sent, it is no longer editable.
                    </div>
                </div>
            </div>

            <div class="parties-grid">
                <div class="party-card" v-for="(party, pIndex) in parties" :key="'party-' + pIndex"
                    :class="{ 'party-selected': selectedParty === pIndex }">
                    <!-- Party Color Accent Top -->
                    <div class="party-accent" :style="{ background: party.gradient }"></div>

                    <!-- Leader Profile Card -->
                    <div class="leader-section">
                        <div class="leader-cover" :style="{ background: party.coverGradient }">
                            <div class="cover-pattern"></div>
                            <div class="party-number-cube font-web">
                                <div class="cube-text">หมายเลข</div>
                                <div class="cube-num">{{ pIndex + 1 }}</div>
                            </div>
                        </div>
                        <div class="leader-avatar-wrapper">
                            <div class="avatar-ring"
                                :style="{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }">
                                <div class="avatar-inner">
                                    <img :src="party.leader.avatar" :alt="party.leader.name" />
                                </div>
                            </div>
                            <div class="leader-badge">
                                <a-icon type="crown" theme="filled" />
                            </div>
                        </div>
                        <div class="leader-info">
                            <h3 class="leader-name font-web">{{ party.leader.name }}</h3>
                            <p class="leader-role font-web">หัวหน้ากลุ่ม</p>
                            <p class="leader-faculty font-web">{{ party.leader.department }}</p>
                        </div>

                        <!-- Party Name Banner -->
                        <div class="party-name-banner font-web" :style="{ background: party.gradient }">
                            <a-icon type="flag" />
                            <span>{{ party.name }}</span>
                        </div>

                        <!-- Slogan -->
                        <p class="party-slogan font-web">"{{ party.slogan }}"</p>

                        <!-- Stats -->
                        <div class="leader-stats">
                            <div class="stat-item">
                                <span class="stat-value">{{ party.leader.staffId }}</span>
                                <span class="stat-label font-web">รหัสพนักงาน</span>
                            </div>
                            <div class="stat-divider"></div>
                            <div class="stat-item font-web">
                                <span class="stat-value">{{ party.leader.experience }}</span>
                                <span class="stat-label">ประสบการณ์</span>
                            </div>
                            <div class="stat-divider"></div>
                            <div class="stat-item font-web">
                                <span class="stat-value">{{ party.leader.position }}</span>
                                <span class="stat-label">ตำแหน่ง</span>
                            </div>
                        </div>
                    </div>

                    <!-- Party Members -->
                    <div class="members-section">
                        <div class="members-header font-web">
                            <a-icon type="usergroup-add" />
                            <span>สมาชิกกลุ่ม ({{ party.members.length }} คน)</span>
                        </div>
                        <div class="members-list">
                            <div class="member-item" v-for="(member, mIndex) in party.members"
                                :key="'member-' + pIndex + '-' + mIndex">
                                <div class="member-avatar-ring" :style="{ borderColor: party.accentColor }">
                                    <img :src="member.avatar" :alt="member.name" />
                                </div>
                                <div class="member-info">
                                    <span class="member-name font-web">{{ member.name }}</span>
                                    <span class="member-position font-web">{{ member.position }}</span>
                                </div>
                                <div class="member-year-badge font-web"
                                    :style="{ background: party.accentColor + '18', color: party.accentColor }">
                                    {{ member.department }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Vote Button -->
                    <div class="vote-action">
                        <a-button type="primary" size="large" block class="vote-btn font-web" :style="{
                            background: selectedParty === pIndex ? '#52c41a' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            borderColor: 'transparent'
                        }" @click="selectParty(pIndex)">
                            <a-icon :type="selectedParty === pIndex ? 'check-circle' : 'heart'" theme="filled" />
                            {{ selectedParty === pIndex ? 'เลือกแล้ว' : 'เลือกกลุ่มนี้' }}
                        </a-button>
                    </div>
                </div>
            </div>

            <!-- Submit Section -->
            <div class="submit-section" v-if="selectedParty !== null">
                <div class="submit-card">
                    <div class="submit-info">
                        <a-icon type="check-circle" theme="filled" class="submit-icon" />
                        <div>
                            <h3 class="font-web">คุณเลือก: {{ parties[selectedParty].name }}</h3>
                            <p class="font-web">กรุณายืนยันการลงคะแนน</p>
                        </div>
                    </div>
                    <a-button type="primary" size="large" class="submit-btn font-web" @click="confirmVote">
                        <a-icon type="safety" />
                        ยืนยันการลงคะแนน
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Election',
    data() {
        return {
            selectedParty: null,
            countdown: {
                days: '03',
                hours: '12',
                minutes: '45',
                seconds: '30',
            },
            countdownInterval: null,
            parties: [
                {
                    name: 'กลุ่มก้าวหน้า IC',
                    slogan: 'พัฒนาองค์กร ยกระดับคุณภาพงาน เพื่อบุคลากรทุกคน',
                    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    coverGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
                    ringGradient: 'conic-gradient(#667eea, #764ba2, #f093fb, #667eea)',
                    accentColor: '#764ba2',
                    leader: {
                        name: 'สมชาย วิชัยกุล',
                        department: 'สำนักงานวิชาการ (Academic Affairs)',
                        staffId: 'IC-1025',
                        experience: '12 ปี',
                        position: 'หน.แผนก',
                        avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff_leader1&backgroundColor=b6e3f4',
                    },
                    members: [
                        {
                            name: 'วรรณา ศรีสุวรรณ',
                            position: 'รองหัวหน้ากลุ่ม',
                            department: 'การเงิน',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff1&backgroundColor=ffd5dc',
                        },
                        {
                            name: 'ประเสริฐ จันทร์แก้ว',
                            position: 'เลขานุการกลุ่ม',
                            department: 'IT',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff2&backgroundColor=c0aede',
                        },
                        {
                            name: 'นภัสสร พงศ์เพชร',
                            position: 'เหรัญญิก',
                            department: 'HR',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff3&backgroundColor=d1f4d9',
                        },
                        {
                            name: 'ธีระพงษ์ รัตนโชติ',
                            position: 'ฝ่ายประชาสัมพันธ์',
                            department: 'PR',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff4&backgroundColor=ffeaa7',
                        },
                    ],
                },
                {
                    name: 'กลุ่มพลังบุคลากร',
                    slogan: 'สิทธิ สวัสดิการ และคุณภาพชีวิตที่ดีของบุคลากร',
                    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    coverGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
                    ringGradient: 'conic-gradient(#f093fb, #f5576c, #feca57, #f093fb)',
                    accentColor: '#f5576c',
                    leader: {
                        name: 'ณัฐวุฒิ เกียรติสกุล',
                        department: 'ฝ่ายบริหารทั่วไป (General Admin)',
                        staffId: 'IC-0872',
                        experience: '15 ปี',
                        position: 'ผู้จัดการ',
                        avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff_leader2&backgroundColor=ffd5dc',
                    },
                    members: [
                        {
                            name: 'อารยา สุขเจริญ',
                            position: 'รองหัวหน้ากลุ่ม',
                            department: 'ทะเบียน',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff5&backgroundColor=b6e3f4',
                        },
                        {
                            name: 'ภัทรพล สมบูรณ์ดี',
                            position: 'เลขานุการกลุ่ม',
                            department: 'ธุรการ',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff6&backgroundColor=ffeaa7',
                        },
                        {
                            name: 'กัลยา อุดมทรัพย์',
                            position: 'เหรัญญิก',
                            department: 'การเงิน',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff7&backgroundColor=c0aede',
                        },
                        {
                            name: 'ศักดิ์ชัย พัฒนาสุข',
                            position: 'ฝ่ายสวัสดิการ',
                            department: 'HR',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff8&backgroundColor=d1f4d9',
                        },
                    ],
                },
                {
                    name: 'กลุ่มรวมใจ MUIC',
                    slogan: 'รวมใจบุคลากร สร้างสรรค์วิทยาลัยที่ดีกว่า',
                    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    coverGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
                    ringGradient: 'conic-gradient(#4facfe, #00f2fe, #43e97b, #4facfe)',
                    accentColor: '#4facfe',
                    leader: {
                        name: 'พิมพ์ใจ ธนาวัฒน์',
                        department: 'ฝ่ายกิจการนักศึกษา (Student Affairs)',
                        staffId: 'IC-0534',
                        experience: '10 ปี',
                        position: 'หน.แผนก',
                        avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff_leader3&backgroundColor=d1f4d9',
                    },
                    members: [
                        {
                            name: 'อนุชา ภูมิใจ',
                            position: 'รองหัวหน้ากลุ่ม',
                            department: 'อาคาร',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff9&backgroundColor=ffd5dc',
                        },
                        {
                            name: 'วิลาวัณย์ สุริยะ',
                            position: 'เลขานุการกลุ่ม',
                            department: 'วิชาการ',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff10&backgroundColor=b6e3f4',
                        },
                        {
                            name: 'ปิยะ มงคลชัย',
                            position: 'เหรัญญิก',
                            department: 'การเงิน',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff11&backgroundColor=ffeaa7',
                        },
                        {
                            name: 'จิราภา วัฒนากร',
                            position: 'ฝ่ายสื่อสารองค์กร',
                            department: 'PR',
                            avatar: 'https://api.dicebear.com/7.x/personas/svg?seed=staff12&backgroundColor=c0aede',
                        },
                    ],
                },
            ],
        };
    },
    mounted() {
        this.startCountdown();
    },
    beforeDestroy() {
        if (this.countdownInterval) clearInterval(this.countdownInterval);
    },
    methods: {
        startCountdown() {
            const targetDate = new Date();
            targetDate.setDate(targetDate.getDate() + 3);
            targetDate.setHours(23, 59, 59, 0);

            this.countdownInterval = setInterval(() => {
                const now = new Date();
                const diff = targetDate - now;
                if (diff <= 0) {
                    clearInterval(this.countdownInterval);
                    this.countdown = { days: '00', hours: '00', minutes: '00', seconds: '00' };
                    return;
                }
                const d = Math.floor(diff / (1000 * 60 * 60 * 24));
                const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
                const m = Math.floor((diff / (1000 * 60)) % 60);
                const s = Math.floor((diff / 1000) % 60);
                this.countdown = {
                    days: String(d).padStart(2, '0'),
                    hours: String(h).padStart(2, '0'),
                    minutes: String(m).padStart(2, '0'),
                    seconds: String(s).padStart(2, '0'),
                };
            }, 1000);
        },
        selectParty(index) {
            this.selectedParty = this.selectedParty === index ? null : index;
        },
        confirmVote() {
            this.$confirm({
                title: 'ยืนยันการลงคะแนน',
                content: `คุณต้องการเลือก "${this.parties[this.selectedParty].name}" ใช่หรือไม่? การลงคะแนนไม่สามารถเปลี่ยนแปลงได้`,
                okText: 'ยืนยัน',
                cancelText: 'ยกเลิก',
                centered: true,
                onOk: () => {
                    this.$message.success('ลงคะแนนเรียบร้อยแล้ว ขอบคุณที่ร่วมใช้สิทธิ์');
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
/* ============================================
   Election Page — Main Styles
   ============================================ */

.election-page {
    min-height: 100vh;
    // background: #f0f2f5;
    font-family: 'Prompt', 'Noto Sans Thai', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ---- Hero Section ---- */
.election-hero {
    position: relative;
    overflow: hidden;
    padding: 60px 24px 80px;
    text-align: center;
    color: #000000;
}

.hero-bg-shapes {
    position: absolute;
    inset: 0;
    pointer-events: none;
    overflow: hidden;

    .shape {
        position: absolute;
        border-radius: 50%;
        opacity: 0.05;
        animation: floatShape 8s ease-in-out infinite;
    }

    .shape-1 {
        width: 400px;
        height: 400px;
        background: #667eea;
        top: -100px;
        left: -80px;
        animation-delay: 0s;
    }

    .shape-2 {
        width: 300px;
        height: 300px;
        background: #f093fb;
        top: 50%;
        right: -60px;
        animation-delay: 2s;
    }

    .shape-3 {
        width: 250px;
        height: 250px;
        background: #4facfe;
        bottom: -60px;
        left: 40%;
        animation-delay: 4s;
    }
}

@keyframes floatShape {

    0%,
    100% {
        transform: translateY(0) scale(1);
    }

    50% {
        transform: translateY(-30px) scale(1.05);
    }
}

.hero-content {
    position: relative;
    z-index: 1;
    max-width: 700px;
    margin: 0 auto;
}

.hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(118, 75, 162, 0.08);
    border: 1px solid rgba(118, 75, 162, 0.15);
    border-radius: 30px;
    padding: 8px 20px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    margin-bottom: 20px;
    color: #764ba2;

    i {
        font-size: 14px;
    }
}

.hero-title {
    font-size: 42px;
    font-weight: 800;
    margin-bottom: 12px;
    line-height: 1.2;
    letter-spacing: -0.5px;
    color: #000000;

    .accent {
        background: linear-gradient(135deg, #667eea, #f093fb, #fa8c16);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }
}

.hero-subtitle {
    font-size: 16px;
    color: #434343;
    margin-bottom: 32px;
    line-height: 1.6;
}

/* ---- Countdown Timer ---- */
.hero-timer {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 16px 32px;
}

.timer-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 56px;
}

.timer-value {
    font-size: 32px;
    font-weight: 800;
    color: #000000;
    line-height: 1;
}

.timer-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1.2px;
    color: #8c8c8c;
    margin-top: 4px;
}

.timer-separator {
    font-size: 28px;
    font-weight: 700;
    color: #bfbfbf;
    margin-top: -12px;
}

/* ---- Content Section ---- */
.election-content {
    max-width: 1280px;
    margin: -40px auto 0;
    padding: 0 24px 60px;
    position: relative;
    z-index: 2;
}

.section-header {
    text-align: center;
    margin-bottom: 40px;
    background: #fff;
    border-radius: 20px;
    padding: 28px 24px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
}

.section-title {
    font-size: 24px;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 6px;

    i {
        margin-right: 8px;
        color: #667eea;
    }
}

.section-desc {
    font-size: 14px;
    color: #8c8c8c;
    margin: 0;
}

/* ---- Parties Grid ---- */
.parties-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    gap: 28px;
}

/* ---- Party Card ---- */
.party-card {
    background: #fff;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    border: 2px solid transparent;
    position: relative;

    &:hover {
        transform: translateY(-6px);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
    }

    &.party-selected {
        border-color: #52c41a;
        box-shadow: 0 8px 32px rgba(82, 196, 26, 0.2);
    }
}

.party-accent {
    height: 5px;
}

/* ---- Leader Section ---- */
.leader-section {
    text-align: center;
    padding-bottom: 20px;
}

.leader-cover {
    height: 140px;
    position: relative;
    overflow: hidden;

    .cover-pattern {
        position: absolute;
        inset: 0;
        background-image:
            radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 40%),
            radial-gradient(circle at 50% 80%, rgba(0, 0, 0, 0.05) 0%, transparent 50%);
    }

    .party-number-cube {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 76px;
        height: 76px;
        background: #ffffff;
        border-radius: 14px;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: 2px solid rgba(255, 255, 255, 0.95);
        transition: all 0.3s ease;

        .cube-text {
            font-size: 11px;
            font-weight: 700;
            color: #8c8c8c;
            line-height: 1;
            margin-bottom: 4px;
        }

        .cube-num {
            font-size: 32px;
            font-weight: 900;
            color: #1a1a2e;
            line-height: 1;
        }
    }
}

.leader-avatar-wrapper {
    position: relative;
    display: inline-block;
    margin-top: -55px;
}

.avatar-ring {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    padding: 4px;
    animation: ringRotate 4s linear infinite;
}

@keyframes ringRotate {
    0% {
        filter: hue-rotate(0deg);
    }

    100% {
        filter: hue-rotate(360deg);
    }
}

.avatar-inner {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
    background: #fff;
    padding: 3px;

    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
        background: #f0f2f5;
    }
}

.leader-badge {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ffd700, #ffaa00);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(255, 170, 0, 0.4);
    border: 3px solid #fff;
    z-index: 2;

    i {
        color: #fff;
        font-size: 14px;
    }
}

.leader-info {
    margin-top: 14px;
    padding: 0 20px;
}

.leader-name {
    font-size: 22px;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 2px;
}

.leader-role {
    font-size: 14px;
    font-weight: 600;
    color: #667eea;
    margin-bottom: 2px;
}

.leader-faculty {
    font-size: 13px;
    color: #8c8c8c;
    margin-bottom: 0;
}

/* ---- Party Name Banner ---- */
.party-name-banner {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
    padding: 8px 24px;
    border-radius: 30px;
    color: #fff;
    font-size: 15px;
    font-weight: 600;

    i {
        font-size: 14px;
    }
}

.party-slogan {
    font-size: 14px;
    color: #595959;
    font-style: italic;
    margin: 14px 24px 0;
    line-height: 1.5;
}

/* ---- Leader Stats ---- */
.leader-stats {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    margin: 20px 20px 0;
    background: #f8f9fc;
    border-radius: 16px;
    padding: 16px 12px;
}

.stat-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.stat-value {
    font-size: 18px;
    font-weight: 800;
    color: #1a1a2e;
    line-height: 1;
}

.stat-label {
    font-size: 11px;
    color: #8c8c8c;
    margin-top: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.stat-divider {
    width: 1px;
    height: 32px;
    background: #e8e8e8;
}

/* ---- Members Section ---- */
.members-section {
    padding: 0 20px 8px;
    margin-top: 16px;
}

.members-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #1a1a2e;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;

    i {
        font-size: 16px;
        color: #667eea;
    }
}

.members-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.member-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    background: #fafbfd;
    border-radius: 14px;
    transition: all 0.25s ease;

    &:hover {
        background: #f0f2ff;
        transform: translateX(4px);
    }
}

.member-avatar-ring {
    width: 44px;
    height: 44px;
    min-width: 44px;
    border-radius: 50%;
    border: 2px solid;
    padding: 2px;
    flex-shrink: 0;

    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
        background: #f0f2f5;
    }
}

.member-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.member-name {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a2e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.member-position {
    font-size: 12px;
    color: #8c8c8c;
}

.member-year-badge {
    font-size: 12px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 8px;
    white-space: nowrap;
    flex-shrink: 0;
}

/* ---- Vote Action ---- */
.vote-action {
    padding: 16px 20px 20px;
}

.vote-btn {
    height: 48px !important;
    border-radius: 14px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.3s ease !important;
    border: none !important;

    &:hover {
        opacity: 0.9;
        transform: scale(1.01);
    }

    i {
        font-size: 18px;
    }
}

/* ---- Submit Section ---- */
.submit-section {
    margin-top: 36px;
    animation: slideUp 0.4s ease-out;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.submit-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 20px;
    padding: 24px 28px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid #f0f0f0;
    flex-wrap: wrap;
    gap: 16px;
}

.submit-info {
    display: flex;
    align-items: center;
    gap: 16px;

    .submit-icon {
        font-size: 36px;
        color: #52c41a;
    }

    h3 {
        font-size: 18px;
        font-weight: 700;
        color: #1a1a2e;
        margin-bottom: 2px;
    }

    p {
        font-size: 13px;
        color: #8c8c8c;
        margin: 0;
    }
}

.submit-btn {
    height: 48px !important;
    border-radius: 14px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    padding: 0 32px !important;
    background: linear-gradient(135deg, #52c41a, #389e0d) !important;
    border: none !important;

    &:hover {
        opacity: 0.9;
        box-shadow: 0 4px 16px rgba(82, 196, 26, 0.35);
    }
}

/* ---- Responsive ---- */
@media (max-width: 768px) {
    .hero-title {
        font-size: 28px;
    }

    .hero-timer {
        padding: 12px 16px;
        gap: 8px;
    }

    .timer-value {
        font-size: 22px;
    }

    .timer-item {
        min-width: 40px;
    }

    .parties-grid {
        grid-template-columns: 1fr;
    }

    .submit-card {
        flex-direction: column;
        text-align: center;
    }

    .submit-info {
        flex-direction: column;
    }

    .submit-btn {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .election-hero {
        padding: 40px 16px 60px;
    }

    .hero-title {
        font-size: 24px;
    }

    .hero-subtitle {
        font-size: 14px;
    }

    .election-content {
        padding: 0 12px 40px;
    }

    .leader-name {
        font-size: 18px;
    }
}
</style>
